import { Stepper } from "@mantine/core";
export const stepperProps = Stepper.extend({});
